export const SUBMIT_REQUEST = 'SUBMIT_REQUEST'
export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS'
export const SUBMIT_FAIL = 'SUBMIT_FAIL'
export const SUBMIT_RESET = 'SUBMIT_RESET'